export default {
    forecast_scenario_0: 'Past estimate',
    forecast_scenario_1: 'Reference',
    forecast_scenario_2: 'Better forecast',
    forecast_scenario_3: 'Worse forecast',
    forecast_scenario_4: 'Slower Met Need and Education',
    forecast_scenario_5: 'Faster Met Need and Education',
    forecast_scenario_6: 'Fastest Met Need and Education',
    forecast_scenario_7: 'SDG Met Need and Education',
    forecast_scenario_14: 'Safer environment',
    forecast_scenario_15: 'Improved behavioral and metabolic risk factors',
    forecast_scenario_16: 'Combined',
    forecast_scenario_18: 'Improved childhood nutrition and vaccination',
    forecast_scenario_60: 'Pre-published estimates',
    forecast_scenario_65: 'Observed data',
    forecast_scenario_66: 'Current projection',
    forecast_scenario_67: 'Universal masks',
    forecast_scenario_68: 'Worse',
    forecast_scenario_69: 'No vaccine',
    forecast_scenario_70: 'Rapid vaccine rollout',
    forecast_scenario_71: 'Rapid vaccine rollout to high-risk',
    forecast_scenario_72: 'Variant spread',
    forecast_scenario_73: 'Third dose',
    forecast_scenario_74: 'Reduced Hesitancy',
    forecast_scenario_75: 'Antivirals',
    forecast_scenario_100: 'Baseline',
    forecast_scenario_101: 'Mean vaccination effectiveness',
    forecast_scenario_102: 'Low vaccination effectiveness',
    forecast_scenario_103: 'High vaccination effectiveness',
    forecast_scenario_104: 'Mean vaccination effectiveness + Mean Wolbachia effectiveness',
    forecast_scenario_105: 'Low vaccination effectiveness + Mean Wolbachia effectiveness',
    forecast_scenario_106: 'High vaccination effectiveness + Mean Wolbachia effectiveness',
    forecast_scenario_107: 'Mean vaccination effectiveness + Low Wolbachia effectiveness',
    forecast_scenario_108: 'Low vaccination effectiveness + Low Wolbachia effectiveness',
    forecast_scenario_109: 'High vaccination effectiveness + Low Wolbachia effectiveness',
    forecast_scenario_110: 'Mean vaccination effectiveness + High Wolbachia effectiveness',
    forecast_scenario_111: 'Low vaccination effectiveness + High Wolbachia effectiveness',
    forecast_scenario_112: 'High vaccination effectiveness + High Wolbachia effectiveness',
    forecast_scenario_10002: 'Alternative 1: Isa after Dara',
    forecast_scenario_10003: 'Alternative 2: Isa frontline',
    forecast_scenario_10005: 'Historic data',
    forecast_scenario_10006: 'Projected data',
};
